import React from "react";
import { MdDelete } from "react-icons/md";
import BoxShadow from "../../../../../../../Common/Components/BoxShadow";
import {
  GenderRender,
  RenderPrice,
  sepMony,
} from "../../../../../../../Common/Function";
const CardTime = ({ options, time, deleteItem, noBtn, day }) => {
  return (
    <div className="col-md-3 mt-1 mb-2">
      <BoxShadow
        style={{
          margin: "0",
          padding: "10px",
        }}
      >
        {options.needtitle && (
          <h6 className="d-flex justify-content-between">
            <span>عنوان : </span>
            <span>{time.title}</span>
          </h6>
        )}
        {options.needgender && (
          <h6 className="d-flex justify-content-between">
            <span>شیفت : </span>
            <span>{GenderRender(time.gender)}</span>
          </h6>
        )}
        {options.needcapacity && (
          <h6 className="d-flex justify-content-between">
            <span>ظرفیت : </span>
            <span>{time.capacity}</span>
          </h6>
        )}
        {options.needsession && (
          <h6 className="d-flex justify-content-between">
            <span>تعداد جلسه : </span>
            <span>{time.session}</span>
          </h6>
        )}


        <h6 className="d-flex justify-content-between">
          <span>
            قیمت خرید
            {options.needchild && " بزرگسال "}
            :
          </span>
          <span>{sepMony(time.buyprice)}</span>
        </h6>

        <h6 className="d-flex justify-content-between">
          <span>
            قیمت فروش
            {options.needchild && " بزرگسال "}
            :
          </span>
          <span>{RenderPrice(time)}</span>
        </h6>

        <h6 className="d-flex justify-content-between">
          <span>
            قیمت گیشه
            {options.needchild && " بزرگسال "}
            :
          </span>
          <span>{sepMony(time.boxofficeprice)}</span>
        </h6>

        {options.needchild &&
          <>
            <h6 className="d-flex justify-content-between">
              <span> قیمت خرید خردسال : </span>
              <span>{sepMony(time.buychildprice)}</span>
            </h6>

            <h6 className="d-flex justify-content-between">
              <span> قیمت فروش خردسال : </span>
              <span>{sepMony(time.childprice)}</span>
            </h6>

            <h6 className="d-flex justify-content-between">
              <span> قیمت گیشه  خردسال : </span>
              <span>{sepMony(time.boxofficechildprice)}</span>
            </h6>
          </>
        }

        <h6 className="d-flex justify-content-between">
          <span>زمان : </span>
          <span> {`${time.start} تا ${time.end}`}</span>
        </h6>
        {!noBtn && (
          <div className="d-flex justify-content-center">
            <button
              className="btn btn-danger"
              onClick={() => {
                deleteItem(time._id, day);
              }}
            >
              <MdDelete />
            </button>{" "}
          </div>
        )}
      </BoxShadow>
    </div>
  );
};

export default CardTime;
